import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Address } from "../../types";

const MASKED_VALUE = "****";

const FormattedAddress = ({
  address,
  identifier,
  masked = false,
}: {
  address: Address;
  identifier: string;
  masked?: boolean;
}) => {
  const theme = useTheme();
  const addressLineSeparator = ", ";
  const sep = masked ? "" : addressLineSeparator;
  const mask = (value: string | undefined) =>
    masked && value ? MASKED_VALUE : value;

  return (
    <Box sx={{ paddingTop: theme.tokens.FuelSpacing2 }}>
      <Typography data-testid={`${identifier}-name`}>
        {address.name && `${mask(address.name)}${sep}`}
      </Typography>
      <Typography data-testid={`${identifier}-addressLine1`}>
        {address.addressLine1 && `${mask(address.addressLine1)}${sep}`}
      </Typography>

      <Typography data-testid={`${identifier}-addressLine2`}>
        {address.addressLine2 && `${mask(address.addressLine2)}${sep}`}
      </Typography>

      <Typography data-testid={`${identifier}-addressLine3`}>
        {masked && (address.city || address.state || address.postalCode) ? (
          `${MASKED_VALUE}${sep}`
        ) : (
          <>
            {address.city}
            {address.state ? ", " : ""}
            {address.state} {address.postalCode}
            {address.postalCode && addressLineSeparator}
          </>
        )}
      </Typography>

      <Typography data-testid={`${identifier}-address-countryCode-phoneNumber`}>
        {masked && (address.country || address.phoneNumber) ? (
          MASKED_VALUE
        ) : (
          <>
            {address.country}
            {address.phoneNumber ? "- " : ""}
            {address.phoneNumber}
          </>
        )}
      </Typography>
    </Box>
  );
};

export default FormattedAddress;
